export default __webpack_public_path__ + "static/media/livingRoom1.8203eedf.jpg";